import React from "react";
import { ChevronRightIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface BreadcrumbNavProps {
    items: BreadcrumbItem[];
}

export default function BreadcrumbNav({ items }: BreadcrumbNavProps) {
    return (
        <nav className="flex items-center space-x-2 text-base font-medium">
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    {index > 0 && <ChevronRightIcon className="h-4 w-4 mx-2" />}
                    {item.href ? (
                        <Link
                            to={item.href}
                            className="text-gray-500 hover:text-gray-700 transition-colors"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span className="text-gray-900 font-medium">{item.label}</span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
}
